<template>
    <b-container fluid>
        <b-row v-if="!!pqrs">
            <b-col cols="12" md="6" class="mt-3">
                <app-pie-chart
                    title="PQR's Por Tipo"
                    :chart-data="pqrs.byType"
                ></app-pie-chart>
            </b-col>
            <b-col cols="12" md="6" class="mt-3">
                <app-pie-chart
                    title="PQR's Por Estado"
                    :chart-data="pqrs.byStatus"
                ></app-pie-chart>
            </b-col>
            <b-col cols="12" md="6" class="mt-3">
                <app-pie-chart
                    title="PQR's Por Usuario"
                    :chart-data="pqrs.byUser"
                ></app-pie-chart>
            </b-col>
            <b-col cols="12" md="6" class="mt-3">
                <app-pie-chart
                    title="PQR's Por Cliente"
                    :chart-data="pqrs.byClient"
                ></app-pie-chart>
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col>
                <b-alert variant="info" show>Esperando Información</b-alert>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import appPieChart from '../../../Charts/PieChart'
export default {
    components: {
        appPieChart,
    },
    props: {
        pqrs: {
            type: Object,
        },
    },
    data: () => ({}),
    computed: {},
    methods: {},
}
</script>
